import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  UncontrolledPopover,
  PopoverBody,
} from 'reactstrap';

import FileStatus from './Status';

import { isEllipsisActive } from '../../helpers/App';

const FileTitle = ({
  className,
  file,
  fileTo,
  inPopover,
}) => {
  const [mounted, setMounted] = useState(false);
  const elRef = useRef();

  useEffect(() => {
    setMounted(true);
  }, []);

  const pointToNone = !!file.pointToNone;

  return (
    <>
      <h5 className={className} id={`file-title-${file.uuid}`}>
        {pointToNone && (
          <>
            {(file.type === 'link' && !file.html_code) ? (
              <span aria-label={file.display_name} ref={elRef}>
                <i className="fas fa-link-horizontal" />{' '}
                {file.display_name}
              </span>
            ) : (
              <span aria-label={file.display_name} ref={elRef}>
                {file.display_name}
              </span>
            )}
          </>
        )}
        {!pointToNone && (
          <>
            {(file.type === 'link' && !file.html_code) ? (
              <a href={file.path} aria-label={file.display_name} target="_blank" rel="noopener noreferrer" ref={elRef}>
                <i className="fas fa-link-horizontal" />{' '}
                {file.display_name}
              </a>
            ) : (
              <>
                {fileTo ? (
                  <Link to={fileTo} aria-label={file.display_name} innerRef={elRef}>
                    {file.display_name}
                  </Link>
                ) : (
                  <span aria-label={file.display_name} ref={elRef}>
                    {file.display_name}
                  </span>
                )}
              </>
            )}
          </>
        )}
        <FileStatus
          file={file}
        />
      </h5>
      {(mounted && !inPopover && isEllipsisActive(elRef.current)) && (
        <UncontrolledPopover
          className="file-popover"
          container={`#file-element-${file.uuid}`}
          trigger="hover"
          fade={false}
          placement="top"
          positionFixed={true}
          target={`file-title-${file.uuid}`}
        >
          <PopoverBody>
            <h5 className="masonry-item-title">
              {(file.type === 'link' && !file.html_code) ? (
                <a href={file.path} aria-label={file.display_name} target="_blank" rel="noopener noreferrer">
                  {file.display_name}
                </a>
              ) : (
                <>
                  {fileTo ? (
                    <Link to={fileTo} aria-label={file.display_name}>
                      {file.display_name}
                    </Link>
                  ) : (
                    <span aria-label={file.display_name}>
                      {file.display_name}
                    </span>
                  )}
                </>
              )}
            </h5>
          </PopoverBody>
        </UncontrolledPopover>
      )}
    </>
  );
};

FileTitle.propTypes = {
  className: PropTypes.string,
  file: PropTypes.object.isRequired,
  fileTo: PropTypes.object,
  inPopover: PropTypes.bool,
};

FileTitle.defaultProps = {
  className: '',
  fileTo: null,
  inPopover: false,
};

export default FileTitle;
